import { Save } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const SaveLeadDialog = ({ open, onOpenChange, pending, onCancel, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="bg-[#0f1419] border-gray-700">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-white flex items-center gap-2">
          <Save className="h-5 w-5 text-[text-ism-teal]" />
          Save Lead to CRM
        </AlertDialogTitle>
        <AlertDialogDescription className="text-gray-400">
          {pending && (
            <>
              You are about to save the following lead:
              <div className="mt-3 p-3 bg-white/5 rounded-lg border border-gray-700">
                {pending.company.personName && <p className="text-white font-medium">{pending.company.personName}</p>}
                {pending.company.personTitle && <p className="text-gray-400 text-sm">{pending.company.personTitle}</p>}
                {pending.company.companyName && <p className="text-[text-ism-teal] text-sm">at {pending.company.companyName}</p>}
                {!pending.company.personName && pending.company.title && <p className="text-white font-medium">{pending.company.title}</p>}
              </div>
              <p className="mt-3">This will create a new lead entry in your CRM.</p>
            </>
          )}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="bg-transparent border-gray-700 text-white hover:bg-white/10" onClick={onCancel}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-[text-ism-teal] hover:bg-[text-ism-teal]/90 text-black">Yes, Save Lead</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
